import { ErrorHandler, Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class LogErrorHandler implements ErrorHandler {
    public handleError(error: any): void {
        console.error(error);
    }

}
